export const isDev = "__dev";
export const serviceUrl = "__serviceUrl";
